<div class="right-corner" [ngSwitch]="status" data-qa="cto-status">
  <ng-template ngSwitchCase="1">
    {{ 'cto.contracts.status.waiting.since' | translate }}
    {{ createdAt | taxDate }}
  </ng-template>
  <ng-template ngSwitchCase="2">
    {{ 'cto.contracts.status.active.since' | translate }}
    {{ endsAt | taxDate }}
  </ng-template>
  <ng-template ngSwitchCase="3">
    {{ 'cto.contracts.status.rejected.since' | translate }}
    {{ updatedAt | taxDate }}
  </ng-template>
  <ng-template ngSwitchCase="4">
    {{ 'cto.contracts.status.annulated.since' | translate }}
    {{ updatedAt | taxDate }}
  </ng-template>
  <ng-template ngSwitchCase="5">
    {{ 'cto.contracts.status.terminated.requested.since' | translate }}
    {{ updatedAt | taxDate }}
  </ng-template>
  <ng-template ngSwitchCase="6">
    {{ 'cto.contracts.status.terminated.since' | translate }}
    {{ endsAt | taxDate }}
  </ng-template>
  <ng-template ngSwitchCase="7">
    {{ 'cto.contracts.status.closed.since' | translate }}
    {{ endsAt | taxDate }}
  </ng-template>
  <ng-template ngSwitchDefault>
    {{ 'cto.contracts.status.unknown.since' | translate }}
  </ng-template>
</div>
